import api from '@/backend/api'

export default {
    getList() {
        return api.get('/sales/order');
    },
}
